import { render } from "./TablaAdministradores.vue?vue&type=template&id=5d67b4a0&scoped=true"
import script from "./TablaAdministradores.vue?vue&type=script&lang=js"
export * from "./TablaAdministradores.vue?vue&type=script&lang=js"

import "./TablaAdministradores.vue?vue&type=style&index=0&id=5d67b4a0&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d67b4a0"]])

export default __exports__